import React, { useState, useEffect } from 'react';
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    IconButton,
} from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Temporalizador from './Temporalizador';
import { useStateValue } from '../../Contexto/store';

//styles
import {
    modalesMensajesGenericos
} from '../Tool/Style';

const useStyles = makeStyles((theme) => createStyles({
    botton: {
        root: {
            margin: theme.spacing(0.5)
        },
        label: {
            textTransform: 'none'
        }
    },
    dialog: {
        padding: theme.spacing(2),
        position: 'absolute',
        top: theme.spacing(5)
    },
    dialogTitle: {
        textAlign: 'center !important'
    },
    dialogContent: {
        textAlign: 'center !important'
    },
    dialogAction: {
        justifyContent: 'center !important'
    },
    titleIcon: {
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.primary.light,
            cursor: 'default'
        },
        '& .MuiSvgIcon-root': {
            fontSize: '8rem',
        }
    }
}));

const IdleTimeOutModal = ({ showModal, handleContinue, handleLogout, remainingTime }) => {

    const [{ etiquetasIdioma, sesionUsuario }, dispatch] = useStateValue();

    // Se declara la variable de estado que representa al idioma para las etiquetas del componente
    const [etiquetas, setEtiquetas] = useState({
        EtiquetasComponente: etiquetasIdioma ? etiquetasIdioma.EtiquetasComponente : DiccionarioEtiquetas.IdiomaDefault.Etiquetas,
        CodigoIdioma: etiquetasIdioma ? etiquetasIdioma.CodigoIdioma : DiccionarioEtiquetas.CodigoIdioma
    });

    useEffect(() => {
        // se llama al dispatch para que como tal se actualice el reducer
        setEtiquetas({
            EtiquetasComponente: etiquetasIdioma ? etiquetasIdioma.EtiquetasComponente : DiccionarioEtiquetas.IdiomaDefault.Etiquetas,
            CodigoIdioma: etiquetasIdioma ? etiquetasIdioma.CodigoIdioma : DiccionarioEtiquetas.CodigoIdioma
        });

    }, [etiquetasIdioma]);

    const classes = useStyles();

    const ContinuarNavegando = () => {
        handleContinue();
    };

    const SalirSitioAutomatico = () => {
        handleLogout(true);
    };

    const SalirSitio = () => {
        handleLogout(false);
    };

    return (
        <Dialog open={showModal} classes={{ paper: classes.dialog }}>
            <DialogTitle className={classes.dialogTitle}>
                <IconButton disableRipple className={classes.titleIcon} size="large">
                    <AccessTimeIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent className={classes.dialogContent}>
                <Typography variant="h6">
                    {etiquetas.EtiquetasComponente.IdleTimeOutModal.Et_txtFinSesionTitulo}
                </Typography>
                <Temporalizador SalirSitio={SalirSitioAutomatico} />
                <Typography variant="subtitle1">
                    {etiquetas.EtiquetasComponente.IdleTimeOutModal.Et_txtFinSeguir}
                </Typography>
            </DialogContent>
            <DialogActions className={classes.dialogAction}>
                <Button
                    text={etiquetas.EtiquetasComponente.General.Et_tbnNo}                    
                    onClick={SalirSitio}
                    //classes={{ root: classes.botton.root, label: classes.botton.label }}
                    style={modalesMensajesGenericos.BotonesNo}
                >
                    {etiquetas.EtiquetasComponente.General.Et_tbnNo}
                </Button>
                <Button
                    text={etiquetas.EtiquetasComponente.General.Et_tbnSi}                   
                    onClick={ContinuarNavegando}
                    //classes={{ root: classes.botton.root, label: classes.botton.label }}
                    style={modalesMensajesGenericos.BotonesOk}
                >
                    {etiquetas.EtiquetasComponente.General.Et_tbnSi}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default IdleTimeOutModal;
